import { HTMLAttributes } from "react";
import { Spinner } from "./Spinner";
import styles from "./Spinner.module.css";
import { cx } from "../utils";

export interface LoadingProps extends HTMLAttributes<HTMLDivElement> {
    size?: "inline" | "standard" | "fullPage";
    label?: string;
}

const sizeClasses = {
    inline: styles.loadingInline,
    standard: styles.loadingStandard,
    fullPage: styles.loadingFullPage
};

const spinnerSizes = {
    inline: "sm",
    standard: "lg",
    fullPage: "lg"
} as const;

export const Loading = ({ size = "standard", label, className, ...props }: LoadingProps) => (
    <div className={cx(styles.loading, sizeClasses[size], className)} role="status" aria-live="polite" {...props}>
        <Spinner size={spinnerSizes[size]} tone="accent" />
        {label ? <span className={styles.label}>{label}</span> : null}
    </div>
);
